export const OTHER_OPTION = '__OTHER__';
export const STUDENT_TYPE_INCOMING = 'incoming';
export const STUDENT_TYPE_OUTGOING = 'outgoing';

export const ACTION_PREFIX = 'UNIVERSITY_SIGN_UP';
export const STATE_NAME = 'universitySignUp';
export const FORM_NAME = 'university-destination';
export const DEBOUNCE_TIME = 300;

export const Actions = {
  LOAD_START: `${ACTION_PREFIX}/LOAD_START`,
  LOAD_DONE: `${ACTION_PREFIX}/LOAD_DONE`,
  LOAD_FAIL: `${ACTION_PREFIX}/LOAD_FAIL`,
  LOAD_UNIVERSITIES_START: `${ACTION_PREFIX}/LOAD_UNIVERSITIES_START`,
  LOAD_UNIVERSITIES_DONE: `${ACTION_PREFIX}/LOAD_UNIVERSITIES_DONE`,
  LOAD_UNIVERSITIES_FAIL: `${ACTION_PREFIX}/LOAD_UNIVERSITIES_FAIL`,
};
